<template>
  <a-modal :visible="visible" @ok="process" @cancel="cancel" :width="getScreen?'100%':'70%'" :confirmLoading="loading.confirm"
    okText="Submit"
    cancelText="Cancel"
    :maskClosable="false">
    <span slot="title"> <a-icon type="reconciliation" />&nbsp;Edit Detail Recapitulation</span>

    <a-form-model
      ref="formDialog"
      :model="formDialog.form"
      :rules="formDialog.rules"
    >
      <a-row :gutter="14">
        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
          <a-row :gutter="14">
            <a-col :xs="{ span: 24 }" :lg="{ span: 24 }">
              <a-form-model-item label="Total Recapitulation (IDR)" prop="total_rekap">
                <a-input-number :min="0" class="m-width-full m-text-align right" @keydown="currencyIndonesianFormat"
                  :formatter="formatterIndonesianCurrency" :parser="parserIndonesianCurrency"
                  v-model="formDialog.form.total_rekap" disabled></a-input-number>
              </a-form-model-item>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 24 }">
              <a-form-model-item label="Document Support" prop="document_support">
                <a-upload :fileList="formDialog.fileList" v-model="formDialog.form.document_support" :remove="handleRemove" :beforeUpload="beforeUpload">
                  <a-button>
                    <a-icon type="upload" />Select File
                  </a-button>
                </a-upload>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-col>
        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
          <a-form-model-item label="Description" prop="description">
            <a-textarea placeholder="Write the note here ... " :rows="5" v-model="formDialog.form.description" />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <a-table
      :rowKey="(record, index) => {return index;}"
      :columns="columnsList"
      :dataSource="dataSource"
      :pagination="pagination"
      :loading="loading.table"
      size="small"
      class="table"
      :scroll="{ x: 400 }"
      bordered
    >
      <template slot="title">
        <div class="m-display-flex space-end">Selected: {{selectedList.length}}</div>
      </template>
      <template slot="no" slot-scope="item,data,index">
        {{ index+1 }}
      </template>
      <template slot="no_klaim" slot-scope="item">
        {{ item.no_klaim }}
      </template>
      <template slot="no_klaim" slot-scope="item">
        {{ item.no_klaim }}
      </template>
      <template slot="create_date" slot-scope="item">
        {{ moment(item.create_dt).format(getStandartFormatDate) }} / {{ item.tlc_create }}
      </template>
      <template slot="member_name" slot-scope="item">
        {{ item.nama_anggota }}
      </template>
      <template slot="total_klaim" slot-scope="item">
        {{ formatCurrency('IDR',item.total_klaim) }}
      </template>
      <template slot="total_klaim_approved" slot-scope="item">
        {{ formatCurrency('IDR',item.total_nilai_klaim_appr) }}
      </template>
      <template slot="action" slot-scope="item">
        <a-checkbox v-model="item.checked" @change="(e)=>{synchCheckedtoOri(e.target.checked,item)}"/>
      </template>
    </a-table>
  </a-modal>
</template>
<script>
import { mapGetters } from "vuex";
import moment from "moment";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import _ from "lodash";

export default {
  name: "DialogProcess",
  mixins: [CurrencyFormat, GlobalMethod],
  props: ["visible","detail"],
  data(){
    let doc_validation = (rule, value, callback) => {
      if (this.formDialog.fileList == null || this.formDialog.fileList.length==0) {
        callback(new Error("Upload File Cannot be Empty!"));
      } else {
        callback();
      }
    };

    const columnsList = [
      {
        title: "#",
        key: "no",
        width: "50px",
        align: "center",
        scopedSlots: { customRender: "no" },
        sorter: (a, b) => a.no - b.no,
      },
      {
        title: "Recapitulation Claim No",
        key: "no_klaim",
        width: "150px",
        align: "center",
        scopedSlots: { customRender: "no_klaim" },
        sorter: (a, b) => a.no_klaim - b.no_klaim,
      },
      {
        title: "Created Date / TLC",
        key: "create_date",
        width: "150px",
        align: "center",
        scopedSlots: { customRender: "create_date" },
        sorter: (a, b) => a.create_dt - b.create_dt,
      },
      {
        title: "Member Name",
        key: "member_name",
        align: "left",
        scopedSlots: { customRender: "member_name" },
        sorter: (a, b) => a.nama_anggota - b.nama_anggota,
      },
      {
        title: "Total Recapitulation Claim",
        key: "total_klaim",
        width: "180px",
        align: "right",
        scopedSlots: { customRender: "total_klaim" },
        sorter: (a, b) => a.total_klaim - b.total_klaim,
      },
      {
        title: "Total Approved",
        key: "total_klaim_approved",
        width: "180px",
        align: "right",
        scopedSlots: { customRender: "total_klaim_approved" },
        sorter: (a, b) => a.total_nilai_klaim_appr - b.total_nilai_klaim_appr,
      },
      {
        title: "Action",
        key: "action",
        width: "65px",
        align: "center",
        scopedSlots: { customRender: "action" },
        fixed: "right"
      },
    ];

    return {
      columnsList,
      loading: {
        confirm: false,
        table: false
      },
      formDialog:{
        form: {
          total_rekap: null,
          description: null,
          document_support: null
        },
        rules: {
          total_rekap: {
            required: true,
            message: "Total Recapitulation is required!",
            trigger: "change",
          },
          description: {
            required: true,
            message: "Description is required!",
            trigger: "change",
          },
          document_support: {
            required: false,
            // validator: doc_validation,
            message: "Document Support is required!",
            trigger: "change",
          },
        },
        fileList:[],
      },
      pagination: {
        onChange: (page) => {},
        pageSize: 4,
        size: "small",
      },
      dataSource: [],
      headSource: [],
      selectedList: []
    }
  },
  computed: {
    ...mapGetters([
      "getAuth",
      "getScreen",
      "getStandartFormatDate"
    ]),
  },
  mounted(){
    this.dataSource = this.detail.dtl
    this.headSource = this.detail.data[0]
    this.selectedListed()
    this.formDialog.form.description = this.headSource.description
  },
  methods:{
    moment,
    process(){
      this.$refs.formDialog.validate((valid) => {
        if (!valid) {
          this.displayMessage("form-warning");
          return;
        }

        let formData = new FormData();
        formData.append("id_rekap_klaim", this.headSource.id_rekap_klaim);
        formData.append("description", this.formDialog.form.description);
        formData.append("total", this.formDialog.form.total_rekap);
        if(this.formDialog.fileList && this.formDialog.fileList.length>0)
          formData.append(`file_support`, this.formDialog.fileList[0]);

        if(this.selectedList.length>0){
          this.selectedList.forEach((element,index) => {
            formData.append(`selected_item[${index}]`, element.id_klaim_kesehatan_hdr);
          });
        }else{
          this.displayMessageValue("error-other", 'No data Selected!');
          return
        }

        this.loading.confirm = true
        this.asyncAxiosPost("rekap_kesehatan/edit",
          "formdata", this.getAuth, formData)
        .then(() => {
          Event.$emit("closeDiagEditRec");
          Event.$emit("fetchData");
          this.displayMessage("success-save");
          this.loading.confirm = false
        })
        .catch(() => {
        });
      })
    },
    cancel(){
      Event.$emit("closeDiagEditRec");
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 10) {
        this.displayMessage("large-file-10mb");
      } else {
        this.formDialog.fileList = [file];
        return false;
      }
    },
    handleRemove() {
      this.formDialog.fileList = [];
    },
    selectedListed(){
      this.selectedList =  this.dataSource.filter(item=>item.checked==true)
      this.formDialog.form.total_rekap = _.sumBy(this.selectedList, function (val) {
        return val.checked? Number(val.total_nilai_klaim_appr) : 0;
      });
    },
    synchCheckedtoOri(val, params){
      this.loading.table = true
      this.dataSource.forEach(element => {
        if(element.id_klaim_kesehatan_hdr==params.id_klaim_kesehatan_hdr){
          element.checked = val
          this.selectedListed()
          this.loading.table = false
        }
      });
    },
  }
}
</script>
<style lang="less">
  .ant-input-number-input{
    text-align: right;
  }
</style>